import axios from 'axios';

export const getPatientResource = patientFhirId => {
    return axios.get(`/fhir/Patient?_id=${patientFhirId}`);
};

export const getPatientNedUserInfo = () => {
    return axios.get('/api/users/me');
};
